/* eslint-disable camelcase */
import { WebStorageStateStore } from "oidc-client-ts";

const authority: any = process.env.VITE_OIDC_CLIENT_AUTHORITY;
const clientId: any = process.env.VITE_OIDC_CLIENT_ID;
const redirectUri: any = process.env.VITE_OIDC_REDIRECT_URI;
const scope: any = process.env.VITE_OIDC_SCOPE;
const responseType = "code";

const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

interface OidcConfig {
  authority: string;
  client_id: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
  loadUserInfo: boolean;
  automaticSilentRenew: boolean;
  userStore: WebStorageStateStore;
  onSigninCallback(): void;
}

const oidcConfig: OidcConfig = {
  authority,
  client_id: clientId,
  redirect_uri: redirectUri,
  response_type: responseType,
  scope,
  loadUserInfo: true,
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback
};

export default oidcConfig;
